const permissionsInitialState = {
  currentPermissions: [],
};

export default permissionsInitialState;
